// EventCard.jsx
import React from "react";
import PropTypes from "prop-types";
import { CiCalendar, CiClock2, CiLocationOn, CiShoppingTag } from "react-icons/ci";

export default function EventCard({
    imageSrc,
    imageAlt,
    categories = [],
    title,
    description,
    dateText = "TBD",
    timeText = "TBD",
    locationText = "TBD",
    priceText = "TBD",
    cta,
    className = "",
}) {
    const isMuted = !cta?.href || cta?.variant === "muted";

    const getCategoryColor = (label, fallback) => {
        switch (label) {
            case "Upcoming":
                return "#d9cfa5";
            case "Class":
                return "#a5bfd9";
            case "Ongoing":
                return fallback || "#84b5a1"; // your existing green/teal
            default:
                return fallback || "#999";
        }
    };
    

    return (
        <article className={["card event-card events_box", className].filter(Boolean).join(" ")}>
            {imageSrc && (
                <img src={imageSrc} className="card-image event_image" alt={imageAlt || "Event cover"} />
            )}

            {Array.isArray(categories) && categories.length > 0 && (
                <div className="chip-list events_categories">
                    {categories.map((cat, i) => (
                        <span
                            key={`${cat.label}-${i}`}
                            className="chip event_category"
                            style={{
                                backgroundColor: getCategoryColor(cat.label, cat.color),
                            }}                            
                        >
                            {cat.label}
                        </span>
                    ))}
                </div>
            )}

            <h2 className="card-title event_name">{title}</h2>
            {description && <p className="event_desc">{description}</p>}

            <div className="event_info">
                <div className="event_info_row">
                    <CiCalendar size={18} />
                    <span className="event_info_desc">{dateText}</span>
                </div>
                <div className="event_info_row">
                    <CiClock2 size={18} />
                    <span className="event_info_desc">{timeText}</span>
                </div>
                <div className="event_info_row">
                    <CiLocationOn size={18} />
                    <span className="event_info_desc">{locationText}</span>
                </div>
                <div className="event_info_row">
                    <CiShoppingTag size={18} />
                    <span className="event_info_desc">{priceText}</span>
                </div>
            </div>

            {isMuted ? (
                <span className="btn event_button is-muted" role="status">
                    {cta?.label || "Coming Soon!"}
                </span>
            ) : (
                <a className="btn btn--green event_button" target="_blank" rel="noreferrer" href={cta.href} aria-label={`${title} – ${cta.label}`}>
                    {cta.label}
                </a>
            )}
        </article>
    );
}

EventCard.propTypes = {
    imageSrc: PropTypes.string,
    imageAlt: PropTypes.string,
    categories: PropTypes.arrayOf(
        PropTypes.shape({ label: PropTypes.string.isRequired, color: PropTypes.string })
    ),
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    dateText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    timeText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    locationText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    priceText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    cta: PropTypes.shape({ label: PropTypes.string, href: PropTypes.string, variant: PropTypes.oneOf(["primary", "muted"]) }),
    className: PropTypes.string,
};
